/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-04 15:15:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-15 16:48:35
 */
// (value) => {
//   return !/[@#$%^&()<>?]/.test(value)
// }
// verify = /[`~!@#$%^&*()\+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\+={}|《》？：“”【】、；‘'，。、]/im
export default (value, verify) => { //验证特殊字符
  // console.log(value, verify.test(value));
  // console.log(verify);
  if(!verify)  return true
  if (!value) return true
  if (verify.test(value)) return false
  else return true
}